import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch, useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Horoscope() {
    const { user } = useAuth();
    const [tab, setTab] = useState("daily");
    const [content, setContent] = useState({ daily: null, monthly: null, yearly: null });
    const [loading, setLoading] = useState(false);

    const fetchHoroscope = async (period) => {
        if (content[period]) return;
        setLoading(true);
        try {
            const res = await authFetch("post", "/horoscope", { period });
            setContent({ ...content, [period]: res.data.text });
        } catch (err) {
            if (err.response?.status === 402) {
                toast.error("Premium required for monthly/yearly readings");
            } else {
                toast.error("Failed to generate horoscope");
            }
        } finally {
            setLoading(false);
        }
    };

    const setTabAndLoad = (period) => {
        setTab(period);
        fetchHoroscope(period);
    };

    React.useEffect(() => { fetchHoroscope("daily"); }, []);

    const isLocked = (period) => !user?.subscription_active && (period === "monthly" || period === "yearly");

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-3xl mx-auto">
                    <p className="label-tracking text-gold">AI Horoscope · Gemini</p>
                    <h1 className="font-serif text-5xl mt-2">The Stars Speak</h1>

                    {/* TABS */}
                    <div className="flex gap-2 mt-8 mb-6 glass p-2 rounded-full w-fit">
                        {["daily", "monthly", "yearly"].map((p) => (
                            <button
                                key={p}
                                onClick={() => setTabAndLoad(p)}
                                className={`px-5 py-2 rounded-full text-sm tracking-widest uppercase transition-all ${
                                    tab === p ? "bg-gold text-[#03030A]" : "text-muted hover:text-gold"
                                }`}
                                style={tab === p ? { background: "linear-gradient(135deg, #E6C387, #F5D68F)", color: "#03030A" } : {}}
                                data-testid={`tab-${p}`}
                            >
                                {p}
                            </button>
                        ))}
                    </div>

                    <div className="glass-gold ai-card p-8 min-h-[300px]" data-testid="horoscope-content-card">
                        {isLocked(tab) ? (
                            <div className="text-center py-12">
                                <p className="font-serif text-3xl">A premium reading awaits</p>
                                <p className="text-muted mt-3">Unlock monthly and yearly horoscopes with Cosmic Premium.</p>
                                <Link to="/subscribe" className="btn-gold-solid inline-block mt-6" data-testid="unlock-horoscope">
                                    Unlock Premium
                                </Link>
                            </div>
                        ) : loading ? (
                            <p className="text-muted italic">Channeling the cosmos...</p>
                        ) : (
                            <p className="font-serif text-lg leading-relaxed whitespace-pre-wrap" data-testid="horoscope-text">
                                {content[tab] || "..."}
                            </p>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}
